(function (Drupal, $, once) {
  if (typeof $.type === 'undefined') {
    $.type = function(obj) {
        return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    };
}

  Drupal.behaviors.orlogshemmetStatusMessages = {
    attach: function (context) {
      const $button = $('.close-status-message', context);

      $(once('orlogshemmetStatusMessages', $button)).on('click', function() {
        let $region = $(this).closest('.status-message');
        let ariaHidden = $region.attr('aria-hidden');
        $region.addClass('status-message--hidden');

        if (ariaHidden === 'false') {
          $region.attr('aria-hidden', 'true');
        }
      });
    }
  };
})(Drupal, jQuery, once);